export default function HomePage() {
  return <div className="p-4 sm:p-6"> Bienvenue sur le dashboard de la clinique !</div>;
}